import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CustomBreadcrumb from "../../../components/common/Breadcrumb/CustomBreadcrumb";
import Title from "../../../components/common/Title/Title";
import httpclient from "../../../components/httpclient";
import { DetailDataCustomer } from "../components/DetailDataCustomer";
import {
  dataBreadcrumb,
  dateFilterMembership,
  initDataMembershipFilter,
  initLoanHistoryFilter,
  loanHistoryColumn,
} from "./constants";
import "./styles.css";
import { Divider, Modal } from "antd";
import CustomTable from "../../../components/common/Table/CustomTable";
import { convertLoanHistory } from "../helpers/convertLoanHistory";
import { AxiosCustomGet } from "../../../components/axios/AxiosCustom";
import Config from "../../../components/axios/Config";
import qs from "qs";
import Cookies from "js-cookie";
import {
  AuthorizationList,
  CanAccess,
} from "../../../components/template/authorization/Authorization";
import { GetImage } from "../../../components/helpers/GetImage";
import { Button } from "react-bootstrap";
import SwalToast from "../../../components/helpers/SwalToast";
import ModalConfirm from "../components/ModalConfirm";

export default function DetailCustomer(props) {
  let { id } = useParams();
  const [record, setRecord] = useState({});
  const [loading, setLoading] = useState(false);
  const [modalImage, setModalImage] = useState(false);
  const [loanHistory, setLoanHistory] = useState([]);
  const [filterInput, setFilterInput] = useState(initLoanHistoryFilter);
  const [filterMembership, setFilterMembership] = useState(
    initDataMembershipFilter
  );
  const [pagination, setPagination] = useState({});
  const [totaRecords, setTotalRecords] = useState();
  const [submitting, setSubmitting] = useState(false);
  const [dataMembership, setDataMembership] = useState({});
  const [selectedDate, setSelectedDate] = useState("all");
  const [modalConfirm, setModalConfirm] = useState(false);
  const detail = props?.location?.state;

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    getLoanHistory();
  }, [filterInput]);

  useEffect(() => {
    getDataMembership();
  }, [filterMembership]);

  const getData = () => {
    setLoading(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}customer/${id}`;
    httpclient
      .GET(url)
      .then((res) => {
        setRecord(res.data.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getDataMembership = () => {
    let data = {
      start_date: filterMembership.startDate,
      end_date: filterMembership.endDate,
    };
    setLoading(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}customer/${id}/membership`;
    httpclient
      .GET(url, data)
      .then((res) => {
        setDataMembership(res.data.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const markAsAgent = () => {
    let url = "";
    dataMembership.isAgent ? (url = "remove-agent") : (url = "make-agent");
    setSubmitting(true);
    httpclient
      .POST(`${process.env.REACT_APP_BASE_API_URL}customer/${id}/${url}`)
      .then((response) => {
        SwalToast.fire({
          icon: "success",
          title: response.data.message,
        });
        getDataMembership();
        setModalConfirm(false);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data.error);
          SwalToast.fire({
            icon: "error",
            title: error.response.data.error.message,
          });
        } else {
          console.log(error);
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const getLoanHistory = () => {
    setLoading(true);
    let data = {
      page: parseInt(filterInput.page),
      size: parseInt(filterInput.pageSize),
      sorting_field: filterInput.sortingField,
      sorting_order: filterInput.sortingOrder,
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}customer/${id}/gadai`;

    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        data,
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        }
      ),
      (response) => {
        setLoading(false);
        setTotalRecords(response.data.data.total_item);
        setLoanHistory(convertLoanHistory(response.data.data.items));
        setPagination({
          current: response.data.data.page,
          pageSize: response.data.data.per_page,
          total: response.data.data.total_item,
        });
      }
    );
  };

  const handleTableChange = (pagination, _, sorter) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      sortingField: sorter?.column?.backend_key || null,
      sortingOrder:
        sorter?.order === "ascend"
          ? "ASC"
          : sorter?.order === "descend"
          ? "DESC"
          : null,
    }));
  };

  const handleShowImage = () => {
    setModalImage(true);
  };

  const onChangeDate = (e) => {
    const { value, key } = e;
    const { startDate, endDate } = value;
    setSelectedDate(key);
    setFilterMembership((prev) => ({
      ...prev,
      startDate,
      endDate,
    }));
  };

  return (
    <div className="px-3">
      <div className="pt-4 d-flex justify-content-between">
        <div className="d-flex flex-column" style={{ fontSize: "13px" }}>
          <Title text={"Detail Nasabah"} />
          <CustomBreadcrumb current={dataBreadcrumb} />
        </div>
      </div>
      <div className="container-detail">
        <div className="profile-container d-flex">
          <div className="d-flex">
            {record?.customer_picture && record?.customer_picture !== " " ? (
              <GetImage
                className="image-profile"
                url={`customer/${id}/picture`}
              />
            ) : (
              <img
                className="image-profile"
                src={`${process.env.REACT_APP_PUBLIC_URL}images/placeholder.png`}
              />
            )}
            <div className="ml-2">
              <p className="color-2C465C">{record?.ktp_name}</p>
              <p className="color-2C465C">ID : {record?.ktp_number}</p>
              <p>
                No. Telepon: {record?.phone_1} / {record?.phone_2}
              </p>
            </div>
          </div>
          <div style={{ justifyContent: "flex-end" }}>
            <div className="text-bold justify-content-end d-flex">
              Status Pinjaman:{" "}
              <span
                style={{
                  color: detail.status === "Aktif" ? "#2EBF2B" : "#F23434",
                }}
              >
                {detail.status}
              </span>
            </div>
            <Button
              disabled={submitting}
              variant={dataMembership?.isAgent && "danger"}
              className={`btn-action btn-delete ${
                !dataMembership?.isAgent && "btn-detail"
              }`}
              onClick={() => setModalConfirm(true)}
              style={{ width: 220 }}
            >
              {!dataMembership?.isAgent
                ? "Jadikan Sebagai Agen"
                : "Hapus dari Agen"}
            </Button>
          </div>
        </div>

        <hr style={{ border: "1px dashed #DCDCDC", margin: "24px 0" }} />

        <div className="d-flex align-items-center">
          <div style={{ fontWeight: "700", fontSize: 16, marginRight: 10 }}>
            Performa Nasabah
          </div>
          {dateFilterMembership.map((item, index) => {
            return (
              <Button
                id={item.key}
                variant="outline-secondary"
                className="btn-filter mr-2"
                active={item.key === selectedDate}
                onClick={() => onChangeDate(item)}
                key={index}
              >
                {item.label}
              </Button>
            );
          })}
        </div>

        <div className="d-flex total-outer-container my-3">
          <div className="col-4 align-items-center center">
            <div
              className="total-value text-center"
              style={{ color: "#2C465C" }}
            >
              {dataMembership?.friendJoined || 0}
            </div>
            <div className="total-label text-center">Teman Bergabung</div>
          </div>
          <Divider className="total-divider" type="vertical" />
          <div className="col-4 text-center">
            <div
              className="total-value text-center"
              style={{ color: "#2C465C" }}
            >
              {dataMembership?.transactionWithReferralCode || 0}
            </div>
            <div className="total-label">Transaksi dari Referral</div>
          </div>
          <Divider className="total-divider" type="vertical" />
          <div className="col-4 text-center">
            <div
              className="total-value text-center"
              style={{ color: "#2C465C" }}
            >
              {dataMembership?.transactionAsAgent || 0}
            </div>
            <div className="total-label">Transaksi sebagai Agen</div>
          </div>
        </div>

        <DetailDataCustomer
          data={record}
          handleShowImage={handleShowImage}
          dataMembership={dataMembership}
        />
      </div>
      {/* <PawnHistory /> */}
      <CanAccess
        role={AuthorizationList.view_customer}
        yes={
          <div className="summary-table-container">
            <div className="detail-bold-text summary-table-title">
              Riwayat Gadai / Pinjaman
            </div>
            <CustomTable
              columns={loanHistoryColumn}
              data={loanHistory}
              pagination={pagination}
              handleTableChange={handleTableChange}
            />
          </div>
        }
      />

      <Modal
        className="modal-image"
        centered
        visible={modalImage}
        onCancel={() => setModalImage(false)}
        footer={null}
        width={"80vw"}
        bodyStyle={{ padding: "1rem" }}
        zIndex={2000}
      >
        <GetImage
          className="w-100 object-fit-contain"
          style={{ height: "80vh" }}
          url={`customer/${id}/ktp-picture`}
        />
      </Modal>
      <ModalConfirm
        data={record}
        dataMembership={dataMembership}
        submittin={submitting}
        markAsAgent={markAsAgent}
        setModalConfirm={setModalConfirm}
        modalConfirm={modalConfirm}
      />
    </div>
  );
}
